import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../common/services/api.service";

@Component({
    selector: "app-home-four",
    templateUrl: "./home-four.component.html",
    styleUrls: ["./home-four.component.scss"],
})
export class HomeFourComponent implements OnInit {
    sliders: any[] = [];

    testSliders: any[] = [
        {
            imageUrl:
                "https://png.pngtree.com/thumb_back/fh260/background/20190828/pngtree-high-tech-molecular-structure-hexagonal-link-medical-image_309769.jpg",
        },
        {
            imageUrl: 
                "https://png.pngtree.com/thumb_back/fh260/background/20190828/pngtree-high-tech-molecular-structure-hexagonal-link-medical-image_309769.jpg",
        },
        {
            imageUrl:
                "https://png.pngtree.com/thumb_back/fh260/background/20190828/pngtree-high-tech-molecular-structure-hexagonal-link-medical-image_309769.jpg",
        },
    ];

    constructor(private apiService: ApiService) {
        this.fillHomeSliders();
    }

    ngOnInit(): void {}

    fillHomeSliders() {
        this.apiService.getHomeSlider().subscribe((res: any) => {
            console.log(res);
            this.sliders = res;
        });
    }
}
